import { render, staticRenderFns } from "./Col4.vue?vue&type=template&id=f338c142&scoped=true"
import script from "./Col4.vue?vue&type=script&lang=js"
export * from "./Col4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f338c142",
  null
  
)

export default component.exports